import { extend } from 'sk-ui/lib/utils/util.js'

import positionForm from './metaData/positionForm'
export default {
  PositionCreate({ commit }, params) {
    this.dispatch('OpenFullDialog', {
      metaData: positionForm
    })
  },
  PositionEdit({ commit }, params) {
    const props = {
      title: '编辑岗位',
      params: {
        id: params.rowIds[0]
      }
    }
    const editForm = extend(true, {}, positionForm)
    this.dispatch('OpenFullDialog', { metaData: editForm, props, clone: false })
  }
}
